const requestVersions = new WeakMap()

export function requestLatest(vm, key, request, onLatest) {
  let versions = requestVersions.get(vm)
  if (!versions) {
    versions = {}
    requestVersions.set(vm, versions)
  }

  const version = (versions[key] || 0) + 1
  versions[key] = version

  return request().then(response => {
    if (versions[key] !== version) return null
    return onLatest(response)
  })
}

export default {
  install(Vue) {
    Vue.prototype.$requestLatest = function(key, request, onLatest) {
      return requestLatest(this, key, request, onLatest)
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/latestRequest.js